import axios from 'axios';
import version from '../../package.json';

const setAxiosLanguage = (lng = window.navigator.language) => {
        axios.defaults.headers.common['accept-language'] = lng;
};

export default setAxiosLanguage;